<script lang="ts">
import { defineComponent, PropType, inject, watch } from 'vue'
import SelectorForm from '@/components/form/SelectorForm.vue'

export default defineComponent({
  name: 'SelectorScale',

  components: {
    SelectorForm,
  },

  props: {
    scale: {
      type: Object as PropType<InputText>,
      required: true,
    },

    namespace: {
      type: String,
      default: '',
    },

    defaultSelectorLabel: {
      type: String,
      default: '選択してください',
    },

    defaultSelectorValue: {
      type: String,
      default: '',
    },

    header: {
      type: String,
      default: '従業員規模',
    },
  },

  emits: [
    'update:scale',
  ],

  setup(props, { emit }) {
    const SCALES = inject<string[]>('SCALES')!

    // 選択肢に存在しない値の場合は空の値で再設定
    // ※ 古いユーザの場合、古い区分で値を保持している場合があり、その場合は強制的に再設定させる。
    watch(() => props.scale.value, () => {
      if (props.scale.value && !SCALES.includes(props.scale.value)) {
        emit('update:scale', '')
      }
    })

    const emitValue = (value: string) => {
      if (typeof value === 'string') {
        emit('update:scale', value)
      } else {
        emit('update:scale', '')
      }
    }

    return {
      // constants
      SCALES,

      // methods
      emitValue,
    }
  }
})
</script>

<template>
  <SelectorForm
    :model-value="scale.value"
    :items="SCALES"
    :default-selector-label="defaultSelectorLabel"
    :default-selector-value="defaultSelectorValue"
    :namespace="namespace"
    :name="scale.name"
    :header="header"
    :validation-scheme="scale.validationScheme"
    @update:model-value="emitValue($event)" />
</template>
